export default __webpack_public_path__ + "static/1970_1980-5f38ebf79a9072cdde7599cefdd3a3d7.jpg";